import { useMemo } from "react";

import { useSelector } from "react-redux";

import { selectAll, selectById } from "./selectors";

import type { RootState } from "../types";

export const useAllCardSubscriptions = (): API.CardTransactionsEntity[] => {
  return useSelector(selectAll);
};

export const useTransactionsForCard = (
  cardId: API.CardId,
): API.CardTransactionsEntity | undefined => {
  return useSelector((state: RootState) => selectById(state, cardId));
};

export function useTransactionByUuid(
  cardId: API.CardId,
  transactionUuid: string,
): API.CardTransaction | undefined {
  const transactionEntity = useTransactionsForCard(cardId);
  const monthlyData = useMemo(
    () => transactionEntity?.data ?? [],
    [transactionEntity?.data],
  );
  const transactions = useMemo(
    () => monthlyData.flatMap((month) => month.transactions),
    [monthlyData],
  );
  const transaction = useMemo(
    () => transactions.find((tx) => tx.id === transactionUuid),
    [transactions, transactionUuid],
  );

  return transaction;
}
